import { Link } from 'react-router-dom';

const benefits = [
  {
    icon: 'ri-vip-crown-line',
    title: '超清画质',
    desc: '1080P至4K超清画质，极致视觉享受',
  },
  {
    icon: 'ri-advertisement-line',
    title: '无广告',
    desc: '纯净观看体验，告别广告打扰',
  },
  {
    icon: 'ri-download-line',
    title: '离线下载',
    desc: '随时随地离线观看，无需网络',
  },
  {
    icon: 'ri-shield-star-line',
    title: '独家内容',
    desc: '海量原创独家内容，会员专属',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '全平台无缝切换，进度自动同步',
  },
  {
    icon: 'ri-customer-service-line',
    title: '专属客服',
    desc: '7×24小时VIP客服通道，优先响应',
  },
];

export default function MembershipBenefits() {
  return (
    <section className="py-16 md:py-20 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
            会员专属福利
          </h2>
          <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto">
            加入91麻豆会员，解锁更多精彩内容和专属权益
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-5 border border-white/10 hover:bg-white/15 transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 mb-3">
                <i className={`${benefit.icon} text-white text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-white mb-1">{benefit.title}</h3>
              <p className="text-sm text-white/70">{benefit.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex px-8 py-3 bg-white text-accent-600 font-medium rounded-md hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            立即加入会员
          </Link>
        </div>
      </div>
    </section>
  );
}